import React, { useCallback, useState } from 'react';
import FreeReviewModal from './FreeReviewModal';

const offers = [
  { icon: 'fa-desktop', title: 'Free Website Audit', description: 'Find usability, performance, SEO and conversion issues that may be holding your website back.', highlights: ['Mobile experience', 'Website performance', 'Basic SEO issues', 'UI/UX observations', 'Conversion opportunities'], cta: 'Request Free Website Audit' },
  { icon: 'fa-line-chart', title: 'Free SEO Report', description: "Get an initial view of your website's search visibility, SEO issues and potential growth opportunities.", highlights: ['Current search visibility', 'Basic technical SEO issues', 'Keyword opportunities', 'On-page observations', 'Competitor overview'], cta: 'Get My Free SEO Report' },
  { icon: 'fa-users', title: 'Free CRM Demo', description: 'See how a CRM can help organize leads, follow-ups and your sales process.', highlights: ['Lead management', 'Follow-up tracking', 'Sales pipeline', 'Team coordination', 'Automation possibilities'], cta: 'Book a Free CRM Demo' },
];

const FreeBusinessReview = () => {
  const [selectedOffer, setSelectedOffer] = useState('');
  const closeModal = useCallback(() => setSelectedOffer(''), []);
  return (
    <>
      <section className="free-review-section" aria-labelledby="free-review-section-title">
        <div className="auto-container">
          <div className="sec-title centered light">
            <div className="title">PRACTICAL FIRST STEP</div>
            <h2 id="free-review-section-title">Start With a Free Business Review</h2>
            <div className="text">Choose the area where your business needs support and get practical guidance from the SwiftMaze team.</div>
          </div>
          <div className="free-review-grid">
            {offers.map((offer) => (
              <article className="free-review-card" key={offer.title}>
                <div className="free-review-icon"><span className={`fa ${offer.icon}`} aria-hidden="true"></span></div>
                <h3>{offer.title}</h3><p>{offer.description}</p>
                <ul>{offer.highlights.map((highlight) => <li key={highlight}>{highlight}</li>)}</ul>
                <button type="button" className="theme-btn btn-style-three" onClick={() => setSelectedOffer(offer.title)}>
                  <span className="txt">{offer.cta}</span>
                </button>
              </article>
            ))}
          </div>
          <p className="free-review-trust-note">Limited complimentary reviews are available based on our team&apos;s current capacity.</p>
        </div>
      </section>
      <FreeReviewModal selectedOffer={selectedOffer} onClose={closeModal} />
    </>
  );
};

export default FreeBusinessReview;
